import gql from "graphql-tag";

export default gql`
  mutation UpdateSite(
    $id: ID!
    $name: String
    $physicalAddress: String
    $region: String
  ) {
    updateSite(
      id: $id
      name: $name
      physicalAddress: $physicalAddress
      region: $region
    ) {
      id
    }
  }
`;



// WEBPACK FOOTER //
// ./src/GraphQL/Mutations/UpdateSite.ts